module.exports = __webpack_public_path__ + "img/nouSomni2_1.baf2e72f.jpg";